import { ReactNode, useState } from 'react';

import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { AnimatedText } from '@/blocks/animations/animated-text';
import { Container } from '@/blocks/components/Container';
import { CenterHeading } from '@/blocks/components/layout';
import link from '@/styles/link.module.scss';
import typography from '@/styles/typography.module.scss';

import { TradingHolidaysModal } from './HolidaysModal';
import styles from './styles.module.scss';

type Props = {
  title: ReactNode;
  subtitle: ReactNode;
};

export function CfdAllMarketsTableHeader({ title, subtitle }: Props) {
  const tr = useTranslations();
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <CenterHeading disableSpacing>
        <AnimatedText className={classNames(typography.h2)}>{title}</AnimatedText>
        <p className={classNames(typography.bodyM, typography.headerSubhead)}>{subtitle}</p>
        <p className={classNames(typography.bodyS, typography.headerSubhead, styles.modalText)}>
          {tr.rich('pages.cfd.all.sections.markets.modal.link', {
            span: (content) => (
              <button className={link.textLink} onClick={() => setOpenModal(!openModal)}>
                {content}
              </button>
            ),
          })}
        </p>
      </CenterHeading>
      <TradingHolidaysModal isOpen={openModal} onClose={() => setOpenModal(false)} />
    </>
  );
}
